const generateUUID = require('./generateUUID');

const requestId = generateUUID();

module.exports.REQUEST_ID_HEADER_NAME = 'X-Request-ID';

module.exports.getRequestId = function getRequestId() {
  return requestId;
};
